import axios from "axios";
import store from "@/store";
import router from "@/routes";

const { token, profile } = store.state.user;

const baseURL = `${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api`;
const api = axios.create({
  baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    Profile: profile
  }
});

api.defaults.headers.common.Accept = "application/json";
api.defaults.headers.common["Content-Type"] = "application/json";
api.interceptors.response.use(
  response => response,
  error => {
    if (typeof error.response === "undefined") {
      // console.log(error);
      // router.push('/502');
      store.dispatch("adicionarNotificacao", "Conexão interrompida. Tente novamente.");
    } else {
      sessionStorage.mensagemErroHttp = error.response.data.errorMessage;
      const { status } = error.response;
      if (
        sessionStorage.mensagemErroHttp !== null &&
        sessionStorage.mensagemErroHttp !== undefined
      ) {
        sessionStorage.httpStatusCode = status;
      }
      switch (status) {
        case 401:
          router.push("/logoff");
          break;
        case 403:
          router.push("/403");
          break;
        case 404:
          router.push("/404");
          break;
        case 408:
          router.push("/408");
          break;
        case 500:
          router.push("/500");
          break;
        case 502:
          router.push("/502");
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
